// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageTitleCount from "@sc/App/Components/Common/PageTitleCount";
import React, { FC } from "react";
import { shallowEqual } from "react-redux";

const MyListsTitleCount: FC<WidgetProps> = () => {
    const wishListsDataView = useAppSelector(
        state => getWishListsDataView(state, state.pages.myLists.getWishListsParameter),
        shallowEqual,
    );

    const wishListsCount = wishListsDataView?.value ? wishListsDataView.pagination?.totalItemCount || 0 : 0;

    return <PageTitleCount countNumber={wishListsCount} countName="List" />;
};

const widgetModule: WidgetModule = {
    component: MyListsTitleCount,
    definition: {
        group: "My Lists",
        displayName: "Title Count",
        allowedContexts: ["MyListsPage"],
    },
};

export default widgetModule;
